"use client";

export const getFormattedTimeLeft = (secondsLeft: number): string => {
  const hours = Math.floor(secondsLeft / 3600);
  secondsLeft %= 3600;
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  const timeParts = [];
  if (hours > 0) {
    timeParts.push(`${hours} hours `);
  }
  if (minutes > 0) {
    timeParts.push(`${minutes} minutes`);
  }
  if (seconds > 0 || timeParts.length === 0) {
    timeParts.push(`${seconds} seconds`);
  }

  // If there are hours and minutes remove the seconds
  if (timeParts.length > 2) {
    timeParts.pop();
  }

  return timeParts.join(" ");
};
